<template>
  <kst-section :title="sectionTitle" class="mt-5">
    <kst-table :data="items">
      <b-table-column
        v-slot="{ column, row }"
        cell-class="kst-client-details-Name"
        field="Name"
        :label="ClientAddressCatalog.Name.Label"
      >
        <kst-output field-only
          :field="column.field" :data="row" :catalog="ClientAddressCatalog"
        />
      </b-table-column>

      <b-table-column
        v-slot="{ column, row }"
        cell-class="kst-client-details-Address"
        field="Address"
        :label="ClientAddressCatalog.Address.Label"
      >
        <kst-output field-only
          :field="column.field" :data="row" :catalog="ClientAddressCatalog"
        />
      </b-table-column>

      <b-table-column
        v-slot="{ column, row }"
        cell-class="kst-client-details-ContactName"
        field="ContactName"
        :label="ClientAddressCatalog.ContactName.Label"
      >
        <kst-output field-only
          :field="column.field" :data="row" :catalog="ClientAddressCatalog"
        />
      </b-table-column>

      <b-table-column
        v-slot="{ column, row }"
        cell-class="kst-client-details-ContactMobile"
        field="ContactMobile"
        :label="ClientAddressCatalog.ContactMobile.Label"
      >
        <kst-output field-only
          :field="column.field" :data="row" :catalog="ClientAddressCatalog"
        />
      </b-table-column>

      <b-table-column
        v-slot="{ column, row }"
        cell-class="kst-client-details-ContactPhone"
        field="ContactPhone"
        :label="ClientAddressCatalog.ContactPhone.Label"
      >
        <kst-output field-only
          :field="column.field" :data="row" :catalog="ClientAddressCatalog"
        />
      </b-table-column>

      <b-table-column
        v-slot="{ column, row }"
        cell-class="kst-client-details-ContactEmail"
        field="ContactEmail"
        :label="ClientAddressCatalog.ContactEmail.Label"
      >
        <kst-output field-only
          :field="column.field" :data="row" :catalog="ClientAddressCatalog"
        />
      </b-table-column>
    </kst-table>
  </kst-section>
</template>

<script>
import Info from "../ClientInfo.js";
import ClientAddressCatalog from "../ClientAddressCatalog.js";

export default {
  props: {
    items: Array
  },
  data: () => ({
    ClientAddressCatalog: ClientAddressCatalog
  }),
  computed: {
    sectionTitle() {
      return Info.Section.Address.Title;
    }
  }
}
</script>